/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zesty_Spicy_Capybara_SingInputs */

const fr_zesty_spicy_capybara_sing = /** @type {(inputs: Zesty_Spicy_Capybara_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par email/nom d'utilisateur`)
};

/**

* @param {Zesty_Spicy_Capybara_SingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const zesty_spicy_capybara_sing = /** @type {((inputs?: Zesty_Spicy_Capybara_SingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zesty_Spicy_Capybara_SingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_zesty_spicy_capybara_sing(inputs)
});